import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { create } from 'zustand';
import { useUserOwnsPlaylist } from '../../savedItems/savedItemsQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import produce from 'immer';
import { persist } from 'zustand/middleware';
import UsageTracker from '../../../utils/UsageTracker';
import { SavePlaylistButton } from './SavePlaylistButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SAVE_PLAYLIST_TOOLTIP_LOCALSTORAGE_KEY = 'academy:savePlaylistTooltipState';
export const useSavePlaylistTooltipState = create()(persist(set => ({
  hasClosedSavePlaylistTooltip: false,
  setClosedTooltip: value => set(produce(state => {
    state.hasClosedSavePlaylistTooltip = value;
  }))
}), {
  name: SAVE_PLAYLIST_TOOLTIP_LOCALSTORAGE_KEY
}));
export const SavePlaylistTooltip = ({
  playlistId,
  children
}) => {
  const {
    hasClosedSavePlaylistTooltip,
    setClosedTooltip
  } = useSavePlaylistTooltipState();
  const userIsOwner = useUserOwnsPlaylist(playlistId);
  const handleActionClick = action => {
    UsageTracker.track('interaction', {
      action,
      playlistId
    });
    setClosedTooltip(true);
  };
  const showTooltip = userIsOwner === false && !hasClosedSavePlaylistTooltip;
  return /*#__PURE__*/_jsx(Tooltip, {
    open: showTooltip,
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.savedItems.tooltips.oneTimeSavePlaylist"
      }), /*#__PURE__*/_jsxs(TFlex, {
        marginBlockStart: "200",
        children: [/*#__PURE__*/_jsx(SavePlaylistButton, {
          onClick: () => handleActionClick('save-playlist-tooltip-save'),
          paddingBlock: "200",
          paddingInline: "600",
          playlistId: playlistId,
          use: "link-on-dark",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.common.save"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: () => handleActionClick('save-playlist-tooltip-close'),
          paddingBlock: "200",
          paddingInline: "600",
          use: "link-on-dark",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.savedItems.tooltips.oneTimeSavePlaylistClose"
          })
        })]
      })]
    }),
    children: children
  });
};
export default SavePlaylistTooltip;